import _asyncToGenerator from "/data/landun/workspace/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.test.js";
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, createSlots as _createSlots, resolveDirective as _resolveDirective, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-29dd9082"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  class: "team-form"
};
var _hoisted_2 = {
  class: "dialog-content-header"
};

var _hoisted_3 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("i", {
    class: "el-icon-info left"
  }, null, -1);
});

var _hoisted_4 = {
  class: "dialog-content-title"
};
var _hoisted_5 = {
  class: "dialog-content-middle"
};
var _hoisted_6 = {
  class: "first-input"
};

var _hoisted_7 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "first-input-title"
  }, " 空间名称支持中文、英文字母、数字、下划线 ", -1);
});

var _hoisted_8 = {
  key: 0,
  class: "second-input"
};

var _hoisted_9 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "spaceUrlTitle"
  }, " 专属空间域名支持英文字母、数字、下划线，建议在十个字符内 ", -1);
});

var _hoisted_10 = {
  key: 1,
  class: "third-input"
};

var _hoisted_11 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("p", {
    class: "label"
  }, "使用产品", -1);
});

import { reactive, ref, computed, onMounted } from 'vue';
import CompanyService from '@/api/company';
import { ElMessage } from 'element-plus';
export default {
  props: {
    // 创建团队方法
    createSpace: {
      type: Function,
      required: true
    },
    // 创建团队提示文字
    createSpaceTitle: {
      type: String,
      default: '',
      required: false
    },
    // 是否开启空间专属域名
    enableBizHost: {
      type: Boolean,
      default: true
    },
    // 创建时是否使用app
    useApp: {
      type: Boolean,
      default: true
    },
    corporationId: {
      type: String,
      default: ''
    },
    appKey: {
      type: String,
      default: ''
    }
  },
  emits: ['handle-close', 'create-success'],
  setup: function setup(__props, _ref) {
    var emit = _ref.emit;
    var props = __props;
    var loading = ref(false); // 新建团队标题是否展示,默认展示

    var displayTitle = ref(true); // 空间名

    var bizName = ref(''); // 空间专属域名

    var bizId = ref(''); // 当前域名

    var hostName = ref("".concat(location.origin, "/"));
    var checkedData = reactive({
      checkedList: []
    });
    var appData = reactive({
      appOptions: []
    });

    var getAppList = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _data$data;

        var data;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return CompanyService.getAppActiveDetail({
                  corporationId: props.corporationId
                });

              case 2:
                data = _context.sent;

                if (((_data$data = data.data) === null || _data$data === void 0 ? void 0 : _data$data.code) === 1) {
                  checkedData.checkedList = [props.appKey];
                  appData.appOptions = data.data.result.filter(function (item) {
                    return item.expiredState === 1 || item.expiredState === 2;
                  }).map(function (item) {
                    return {
                      value: item.appKey,
                      label: item.appName,
                      disabled: !!item.ifCanCreateBiz,
                      tips: item.createBizErrorMsg
                    };
                  });

                  if (!appData.appOptions.length) {
                    ElMessage({
                      message: '您还未开通任何产品',
                      type: 'error'
                    });
                  }
                } else {
                  ElMessage({
                    message: data.data.msg,
                    type: 'error'
                  });
                }

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function getAppList() {
        return _ref2.apply(this, arguments);
      };
    }(); // 关闭新建空间弹窗


    var handleClose = function handleClose() {
      bizName.value = '';
      emit('handle-close');
    }; // 新建空间信息是否完整，空间id正则判断


    var validator = function validator() {
      if (!bizName.value || props.enableBizHost && !bizId.value) {
        ElMessage({
          message: '信息不完整',
          type: 'error'
        });
        return false;
      }

      if (!/^[\u4E00-\u9FA5A-Za-z0-9_]+$/.test(bizName.value)) {
        ElMessage({
          message: '空间名请输入中文、英文字母、数字、下划线',
          type: 'error'
        });
        return false;
      }

      if (/\W+/.test(bizId.value)) {
        ElMessage({
          message: '专属地址只能包含字母数字和下划线',
          type: 'error'
        });
        return false;
      }

      if (props.useApp && !appData.appOptions.length) {
        return ElMessage({
          message: '您还未开通任何产品',
          type: 'error'
        });
        return false;
      }

      if (props.useApp && !checkedData.checkedList.length) {
        ElMessage({
          message: '请先勾选需使用的产品',
          type: 'error'
        });
        return false;
      } // 跳转到创建成功页面


      return true;
    }; // 新建空间


    var handleSubmit = function handleSubmit() {
      if (!validator()) return;
      props.createSpace(bizId.value, bizName.value, checkedData.checkedList).then(function (res) {
        if (res.code === 2000) return;
        emit('create-success', {
          bizId: props.enableBizHost ? bizId.value : res.result.bizId,
          bizName: bizName.value,
          bizUrl: res.result.bizUrl
        });
        bizName.value = '';
      });
    }; // 关闭新建空间弹窗提醒文字


    var closeTitle = function closeTitle() {
      displayTitle.value = false;
    };

    onMounted( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (props.useApp) {
                getAppList();
              }

            case 1:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    })));
    return function (_ctx, _cache) {
      var _component_close = _resolveComponent("close");

      var _component_el_icon = _resolveComponent("el-icon");

      var _component_el_input = _resolveComponent("el-input");

      var _component_el_checkbox = _resolveComponent("el-checkbox");

      var _component_el_tooltip = _resolveComponent("el-tooltip");

      var _component_el_checkbox_group = _resolveComponent("el-checkbox-group");

      var _directive_loading = _resolveDirective("loading");

      return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [_withDirectives(_createElementVNode("div", _hoisted_2, [_hoisted_3, _createElementVNode("div", _hoisted_4, _toDisplayString(__props.createSpaceTitle), 1), _createVNode(_component_el_icon, {
        class: "el-icon-close right",
        onClick: closeTitle
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_close)];
        }),
        _: 1
      })], 512), [[_vShow, displayTitle.value && __props.createSpaceTitle]]), _createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_hoisted_7, _createVNode(_component_el_input, {
        class: "newspace-input",
        modelValue: bizName.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
          return bizName.value = $event;
        }),
        placeholder: "空间名称"
      }, null, 8, ["modelValue"])]), __props.enableBizHost ? (_openBlock(), _createElementBlock("div", _hoisted_8, [_hoisted_9, _createElementVNode("div", null, [_createVNode(_component_el_input, {
        modelValue: bizId.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = function ($event) {
          return bizId.value = $event;
        }),
        placeholder: "空间专属域名"
      }, {
        prepend: _withCtx(function () {
          return [_createTextVNode(_toDisplayString(hostName.value), 1)];
        }),
        _: 1
      }, 8, ["modelValue"])])])) : _createCommentVNode("", true), __props.useApp ? (_openBlock(), _createElementBlock("div", _hoisted_10, [_hoisted_11, _createVNode(_component_el_checkbox_group, {
        class: "custom-checkbox",
        modelValue: _unref(checkedData).checkedList,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = function ($event) {
          return _unref(checkedData).checkedList = $event;
        })
      }, {
        default: _withCtx(function () {
          return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(appData).appOptions, function (actionItem) {
            return _openBlock(), _createBlock(_component_el_tooltip, {
              content: actionItem.tips || '',
              placement: "bottom",
              "show-after": 300,
              key: actionItem.value,
              disabled: !actionItem.tips || actionItem.tips === '0'
            }, _createSlots({
              default: _withCtx(function () {
                return [(_openBlock(), _createBlock(_component_el_checkbox, {
                  label: actionItem.value,
                  key: actionItem.value,
                  checked: actionItem.checked,
                  disabled: actionItem.disabled
                }, {
                  default: _withCtx(function () {
                    return [_createTextVNode(_toDisplayString(actionItem.label), 1)];
                  }),
                  _: 2
                }, 1032, ["label", "checked", "disabled"]))];
              }),
              _: 2
            }, [actionItem.tips ? {
              name: "title",
              fn: _withCtx(function () {
                return [_createTextVNode(_toDisplayString(actionItem.tips), 1)];
              })
            } : undefined]), 1032, ["content", "disabled"]);
          }), 128))];
        }),
        _: 1
      }, 8, ["modelValue"])])) : _createCommentVNode("", true)]), _createElementVNode("div", {
        class: "dialog-footer"
      }, [_createElementVNode("div", {
        class: "twoBtn"
      }, [_createElementVNode("button", {
        class: "twoBtnClose",
        onClick: handleClose
      }, " 取消 "), _createElementVNode("button", {
        class: "twoBtnSubmit",
        type: "primary",
        onClick: handleSubmit
      }, " 提交 ")])])])), [[_directive_loading, loading.value]]);
    };
  }
};